import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doGet, doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const requestPlaybookAction = createAsyncThunk(
  "requestPlaybooks",
  async (_, { rejectWithValue }) => {
    try {
      const response = await doGet(urls?.requestPlaybooks);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createPlaybook = createAsyncThunk(
  "createPlaybook",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await doPost(urls?.createPlaybook, arg);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const retrievePlaybook = createAsyncThunk(
  "retrievePlaybook",
  async (arg, { rejectWithValue }) => {
    try {
      const responseData = await doPost(urls?.retrievePlaybook, arg);
      return responseData;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deletePlaybook = createAsyncThunk(
  "deletePlaybook",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await doPost(urls?.deletePlaybook, arg);

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const viewPlaybookAction = createAsyncThunk(
  "viewPlaybook",
  async (arg, { rejectWithValue }) => {
    try {
      const responseData = await doPost(urls?.viewPlaybookQuestions, arg);
      return responseData;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

export const requestPlaybookSlice = createSlice({
  name: "requestPlaybooks",
  initialState: {
    isLoading: false,
    data: false,
    error: null,
    success: false,
  },
  reducers: {
    requestPlaybookReset: () => {
      return {
        isLoading: false,
        data: false,
        error: null,
        success: false,
      };
    },
  },
  extraReducers: {
    [requestPlaybookAction.pending]: (state) => {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    [requestPlaybookAction.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.data = payload;
      state.error = null;
      state.success = true;
    },
    [requestPlaybookAction.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.success = false;
    },
  },
});

export const createPlaybookSlice = createSlice({
  name: "createPlaybook",
  initialState: {
    isLoading: false,
    data: false,
    error: null,
    success: false,
  },
  reducers: {
    createPlaybookReset: () => {
      return {
        isLoading: false,
        data: false,
        error: null,
        success: false,
      };
    },
  },
  extraReducers: {
    [createPlaybook.pending]: (state) => {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    [createPlaybook.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.data = payload;
      state.error = null;
      state.success = true;
    },
    [createPlaybook.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.success = false;
    },
  },
});

export const retrievePlaybookSlice = createSlice({
  name: "retrievePlaybook",
  initialState: {
    isLoading: false,
    success: false,
    error: null,
    data: false,
  },
  reducers: {
    retrievePlaybookReset: () => {
      return {
        isLoading: false,
        success: false,
        error: null,
        data: false,
      };
    },
  },
  extraReducers: {
    [retrievePlaybook.pending]: (state) => {
      state.isLoading = true;
      state.success = false;
      state.error = null;
    },
    [retrievePlaybook.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.success = true;
      state.error = null;
      state.data = payload;
    },
    [retrievePlaybook.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.success = false;
      state.error = payload;
    },
  },
});

export const deletePlaybookSlice = createSlice({
  name: "deletePlaybook",
  initialState: {
    isLoading: false,
    success: false,
    error: null,
    data: false,
  },
  reducers: {
    deletePlaybookReset: () => {
      return {
        isLoading: false,
        success: false,
        error: null,
        data: false,
      };
    },
  },
  extraReducers: {
    [deletePlaybook.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.success = true;
      state.error = null;
      state.data = payload;
    },
    [deletePlaybook.pending]: (state) => {
      state.isLoading = true;
      state.error = null;
      state.data = false;
    },
    [deletePlaybook.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.success = false;
    },
  },
});

export const viewPlaybookSlice = createSlice({
  name: "viewPlaybook",
  initialState: {
    isLoading: false,
    success: false,
    error: null,
    data: false,
  },
  reducers: {
    viewPlaybookReset: () => {
      return {
        isLoading: false,
        success: false,
        error: null,
        data: false,
      };
    },
  },
  extraReducers: {
    [viewPlaybookAction.pending]: (state) => {
      state.isLoading = true;
      state.error = null;
      state.data = false;
    },
    [viewPlaybookAction.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.success = true;
      state.error = null;
      state.data = payload;
    },
    [viewPlaybookAction.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.success = false;
    },
  },
});

export const { requestPlaybookReset } = requestPlaybookSlice.actions;
export const { createPlaybookReset } = createPlaybookSlice.actions;
export const { retrievePlaybookReset } = retrievePlaybookSlice.actions;
export const { viewPlaybookReset } = viewPlaybookSlice.actions;
export const { deletePlaybookReset } = deletePlaybookSlice.actions;
